import {config} from "./config";
import {request} from "./request";

function getOpenOrderItems(data, cb, fail_cb) {
    request.get.call(this, config.apiList.openOrderItems, data, cb, fail_cb)
}
function uploadUserRightsFile(data, cb, fail_cb) {
    request.post.call(this, config.apiList.uploadUserRightsFile, data, null, cb, fail_cb)
}
var openOrderApi = {
    getOpenOrderItems: getOpenOrderItems,
    uploadUserRightsFile: uploadUserRightsFile
}

export {openOrderApi}